import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

export const map = {
  build_price_configure_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.ACTION_CONFIGURE_VEHICLE
  ),
  build_price_choose_year: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.CHOOSE_MODEL_YEAR
  ),
  build_price_choose_type: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.CHOOSE_VEHICLE_TYPE
  ),
  build_price_select_from_model_list: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.SELECT_FROM_MODEL_LIST
  ),
  build_price_open_compare_widget: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.OPEN_COMPARE_MODELS_WIDGET
  ),
  build_price_select_from_compare_widget: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.SELECT_FROM_COMPARE_MODELS_WIDGET,
    {
      action_cause: 'user_input',
    }
  ),

  // Start: Expand customize
  build_price_expand_color: TrackingEvent.actionCompleted(TrackingConstant.ACTION_CONFIGURE_VEHICLE, 'expand_colors'),
  build_price_expand_mechanical_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_mechanical_options'
  ),
  build_price_expand_safety_feature: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_safety_features'
  ),
  build_price_expand_additional_fee: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_additional_fees'
  ),
  build_price_expand_exterior_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_exterior_options'
  ),
  build_price_expand_interior_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_interior_options'
  ),
  build_price_expand_package: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'expand_packages'
  ),
  // End: Expand customize

  // Start: Select customize
  build_price_select_color: TrackingEvent.actionCompleted(TrackingConstant.ACTION_CONFIGURE_VEHICLE, 'select_color'),
  build_price_select_mechanical_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_mechanical_option'
  ),
  build_price_select_safety_feature: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_safety_feature'
  ),
  build_price_select_additional_fee: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_additional_fee'
  ),
  build_price_select_exterior_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_exterior_option'
  ),
  build_price_select_interior_option: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_interior_option'
  ),
  build_price_select_package: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'select_package'
  ),
  // End: Select customize

  // Start: Build steps menu
  build_price_step_add_options: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'add_options',
    { creative_id: 'add_options' }
  ),
  build_price_step_see_pricing: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'see_pricing',
    { creative_id: 'see_pricing' }
  ),
  build_price_step_get_quote: TrackingEvent.actionCompleted(TrackingConstant.ACTION_CONFIGURE_VEHICLE, 'get_quote', {
    creative_id: 'get_quote',
  }),
  build_price_step_choose_vehicle_type: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'choose_vehicle_type',
    { creative_id: 'choose_vehicle_type' }
  ),
  // End: Build steps menu

  build_price_next_button_vehicle_customization: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    'vehicle_customization'
  ),

  build_summary_change_type: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.CHOOSE_VEHICLE_TYPE
  ),
  build_summary_change_options: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.ADD_OPTION
  ),
  trim_select_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.EXPAND_TRIM
  ),
  trim_select_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.COLLAPSE_TRIM
  ),

  build_select_survey: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, 'select_b&p_survey'),
  build_survey_dissat_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'enter_b&p_survey_dissat_details'
  ),
  build_survey_neutral_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'enter_b&p_survey_neutral_details'
  ),
  build_survey_sat_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'enter_b&p_survey_sat_details'
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
